import styled from 'styled-components'
import Button from './Button'

const ButtonLink = styled(Button.withComponent('a')).attrs(({ target }) => ({
  target,
  rel: target === '_blank' ? 'noopener noreferrer' : undefined,
}))`
  /* overwriting bootstrap hover styles */
  &:hover {
    color: ${({ ghost, theme, white }) =>
      ghost || white ? theme?.['-ds-core-400']?.value : 'white'};
  }
`

export default ButtonLink
